export enum CurationPromotionFeature {
  CurationPromotion = 'isCurationPromotionEnabled',
  CurationPromotionSettings = 'isCurationPromotionSettingsEnabled',
  // 🚨 DON'T REMOVE COMMENT : Register your new feature above
}
